import type { EntityUpgradesList, GameGenerators } from '../types/game-types';
import { useGeneratorsStore } from '../store/zustand/useGeneratorsStore';
import { useUpgradesStore } from '../store/zustand/useUpgradesStore';

/**
 * Minimal game slice needed for `updateStats` and generator tick logic (generators + upgrades).
 * Both slices are read from Zustand at call time.
 */
export type StatsSnapshot = {
  generators: GameGenerators;
  upgrades: EntityUpgradesList;
};

/** Build a stats/tick snapshot from current Zustand generators + upgrades. */
export function buildStatsSnapshot(): StatsSnapshot {
  return {
    generators: useGeneratorsStore.getState().generators,
    upgrades: useUpgradesStore.getState().upgrades,
  };
}
